import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
  Table
} from "react-bootstrap";
import Paginations from "../components/pagination";
import Breadcrumbs from "../components/breadcrumbs";
import { useLocation } from 'react-router-dom';

const CourseContents = () => {

  let location = useLocation();

  return (
    <Container fluid className="p-4">
      <Breadcrumbs />
      <p className="section-title mb-5">{location.pathname == "/home/course-content-all" ? "Course Content All" : location.pathname == "/home/course-contents-video" ? "Course Content Video" : location.pathname == "/home/course-contents-web" ? "Course Content Web" : location.pathname == "/home/assignment-content-all" ? "Assignment Content All" : location.pathname == "/home/assignment-content-video" ? "Assignment Content Video" : "Assignment Content Web"}</p>
      {/* Row for Buttons and Search */}
      <Row className="mb-3 d-flex justify-content-between align-items-center">
        <Col md="6" className="d-flex gap-2">
          <Button variant="secondary" size="sm">Copy</Button>
          <Button variant="secondary" size="sm">CSV</Button>
          <Button variant="secondary" size="sm">Excel</Button>
          <Button variant="secondary" size="sm">PDF</Button>
          <Button variant="secondary" size="sm">Print</Button>
        </Col>
        <Col md="4" className="d-flex justify-content-end align-items-center">
          <Form inline className="d-flex align-items-center w-100">
            <Form.Label className="me-2 mb-0 form-label">Search</Form.Label>
            <Form.Control type="text" size="sm" />
          </Form>
        </Col>
      </Row>

      {/* Table Section */}
      <Row>
        <Table responsive className="scribe-contents-table">
          <thead>
            <tr>
              <th></th>
              <th>Course</th>
              <th>Course Name</th>
              <th>Section Name</th>
              <th>Content URLs</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr></tr>
          </tbody>
        </Table>
      </Row>

      {/* Pagination Footer */}
      <Row>
        <Col className="d-flex justify-content-start disabled">
          Displaying of Records
        </Col>
        <Col className="d-flex justify-content-end">
          <Paginations
          // current_page={paginationData.current_page}
          // page_size={paginationData.page_size}
          // total_page={paginationData.total_page}
          // total_records={paginationData.total_records}
          // clicked_page={setPage}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default CourseContents;
